import { ButtonComponent } from '@components/ButtonComponent'
import { Text } from '@components/Text'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { BUTTON_ACTION_TYPE, TEXT_ELEMENT } from '@/types/components'
import { AVAILABLE_LANGUAGES } from '@/types/language'

const LANGUAGE_LABEL = {
  [AVAILABLE_LANGUAGES.EN]: 'English',
  [AVAILABLE_LANGUAGES.ES_MX]: 'Español'
}

export const LanguageSelectionStep = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const footerKey = `language_selection.footer.${pathname.split('/')[1]}`
  const footerTranslation = t(footerKey)
  const footerHasTranslation = footerTranslation !== footerKey

  return (
    <div className=" flex grow flex-col gap-11 p-6" data-testid="language-selection-step-container">
      <div>
        {Object.values(AVAILABLE_LANGUAGES).map((lng) => (
          <Text
            key={`language-selection-title-${lng}`}
            id={`language-selection-title-${lng}`}
            element={TEXT_ELEMENT.TITLE}
            textKey={t(`language_selection.title`, {
              lng
            })}
          />
        ))}
      </div>

      <div className="flex flex-col gap-5">
        {Object.values(AVAILABLE_LANGUAGES).map((language, index) => (
          <ButtonComponent
            key={`language-${language}`}
            tabIndex={index}
            id={`language-${language}`}
            textKey={LANGUAGE_LABEL[language]}
            buttonAction={{
              type: BUTTON_ACTION_TYPE.SET_LANGUAGE,
              language: language as AVAILABLE_LANGUAGES
            }}
          />
        ))}
      </div>

      {footerHasTranslation && (
        <div className="flex grow items-end" data-testid="project-number-footer">
          <p className="text-center text-xs text-gray-text">{footerTranslation}</p>
        </div>
      )}
    </div>
  )
}
